var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-group',{attrs:{"config":{x:_vm.left,y:_vm.top}}},[_vm._v(" --> "),_c('v-rect',{attrs:{"config":{width: _vm.width+2,height: -_vm.left,fill: '#999999',x:0,y:_vm.height+6,}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }